<template>
<w-sliding-popup ref="slidingPopup" title="라우팅 스크립트 관리" top="50px" width="1000px" :default-content="false" @close="onClose">
<div slot="content" style="height:100%;">
  <div style="height:100%;" class="body-content-no-scroll">
    <el-row class="title-bar vertical-center-boc" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <el-select class="mr-r4" v-model="objCompanyId">
          <el-option v-for="item in vendorList" :key="item.objCompanyId" :label="item.objCompanyName" :value="item.objCompanyId"></el-option>
        </el-select>
        <span class="setting-addel">
          <el-button size="mini" icon="fas fa-plus" @click="onAddScriptButtonClick"></el-button>
          <el-button size="mini" icon="fas fa-minus" @click="onDeleteScriptButtonClick" :disabled="!existSelectedScript"></el-button>
        </span>
      </div>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-table-wrapper v-loading="loading" style="height:calc(100% - 38px);" ref="scriptTable" :data="tableData" :fit-height="true"
      :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" remote pagination @selection-change="onSelectionChange"
      @row-dblclick="onRowDbclick" row-class-name="c-dblclick" :column-default="columnDefault" @condition-change="onTableConditionChange" :total="total">
    </el-table-wrapper>
  </div>
  <w-edit-routing-script-popup ref="editRoutingScriptPopup" @close="onEditRoutingScriptPopupClose"/>
</div>
</w-sliding-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import netdeviceConfigApi from '@/api/config/netdevice/netdevice-info';
import netdeviceSettingApi from '@/api/settings/netdevice/netdevice-settings';
import WEditRoutingScriptPopup from './EditRoutingScriptPopup';

export default {
  name: 'WRoutingScriptManagePopup',
  components: {
    WEditRoutingScriptPopup,
  },
  data() {
    return {
      loading: false,
      showSearchTool: false,
      columnDefault,
      columns: [
        {
          type: 'selection',
        },
        {
          prop: 'templateName',
          width: 200,
          label: '스크립트명',
          remoteProp: 'nt.template_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'templateDescr',
          label: '설명',
          sortable: true,
          remoteProp: 'nt.template_descr',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'script',
          label: '스크립트',
          showOverflowTooltip: true,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      tableData: [],
      total: 0,
      objCompanyId: null,
      vendorList: [],
      selectedTemplates: [],
    };
  },
  computed: {
    existSelectedScript() {
      return this.selectedTemplates.length > 0;
    },
  },
  watch: {
    objCompanyId: {
      handler() {
        this.loadTemplate();
      },
    },
  },
  methods: {
    /**
     * 라우팅 스크립트 관리 팝업을 연다.
     * @author Ju
     * @param  {[type]} objCompanyId [description]
     * @return {[type]}              [description]
     */
    open(objCompanyId) {
      if (isNil(objCompanyId)) {
        this.objCompanyId = objCompanyId;
      }
      this.loadVendorList();
      this.$refs.slidingPopup.open();
    },
    /**
     * 네트워크 장비 벤더 목록을 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadVendorList() {
      netdeviceSettingApi.getTemplateVendorList().then((response) => {
        if (response.data.success) {
          this.vendorList = response.data.data;
          if (isNil(this.objCompanyId)) {
            this.objCompanyId = this.vendorList[0].objCompanyId;
          }
          this.loadTemplate();
        }
      });
    },
    /**
     * 라우팅 템플릿을 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadTemplate() {
      if (this.$refs.scriptTable) {
        this.loadRoutingTemplateScript();
      } else {
        this.$nextTick(() => {
          this.loadRoutingTemplateScript();
        });
      }
    },
    /**
     * 벤더에 대한 라우팅 템플릿 스크립트를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadRoutingTemplateScript() {
      const params = this.$refs.scriptTable.getParameter();
      params.objCompanyId = this.objCompanyId;
      this.loading = true;
      netdeviceConfigApi
        .getRoutingTemplateListOfVendor(params)
        .then((response) => {
          const result = response.data;
          if (result.success) {
            this.tableData = result.data;
            this.total = result.total;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '라우팅 스크립트', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '라우팅 스크립트', false));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * selection change 이벤트 핸들러
     * @author Ju
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     */
    onSelectionChange(selection) {
      this.selectedTemplates = selection;
    },
    /**
     * 스크립트 추가 버튼 클릭 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onAddScriptButtonClick() {
      this.$refs.editRoutingScriptPopup.open(this.objCompanyId);
    },
    /**
     * 테이블 조건 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onTableConditionChange() {
      this.loadTemplate();
    },
    /**
     * 스크립트 row 더블클릭 이벤트 핸들러
     * @author Ju
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onRowDbclick(row) {
      this.$refs.editRoutingScriptPopup.open(this.objCompanyId, row);
    },
    /**
     * 스크립트 편집 팝업 close 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onEditRoutingScriptPopupClose() {
      this.loadTemplate();
    },
    /**
     * 스크립트를 삭제한다.
     * @author Ju
     * @return {[type]} [description]
     */
    onDeleteScriptButtonClick() {
      if (this.selectedTemplates.length > 0) {
        const action = msgUtil.action.DELETE;
        const target = '스크립트';
        this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
          netdeviceSettingApi.deleteNcmTemplateCompany(this.selectedTemplates).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadTemplate();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
        });
      }
    },
    /**
     * 라우팅 스크립트 관리 팝업 close 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onClose() {
      this.$emit('close');
    },
    /**
     * 라우팅 스크립트 관리 팝업을 닫는다.
     * @author Ju
     * @return {[type]} [description]
     */
    close() {
      this.$refs.slidingPopup.visible = false;
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/node/netdevice/popup/RoutingScriptManagePopup.vue